"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../../../");
var constants_1 = require("../constants");
var ux_assets_1 = require("@lifesize/ux-assets");
var getLayout = function (numberOfStreams, selectedLayout, width, height) {
    var positions;
    var layout = constants_1.layouts.get(selectedLayout);
    layout.forEach(function (value, key) {
        if (key <= numberOfStreams) {
            positions = value;
        }
    });
    if (!positions) {
        console.error("No layout " + selectedLayout + " for " + numberOfStreams + " with " + width + " x " + height);
    }
    var scaledPositions = [];
    positions.forEach(function (p) {
        var w = p[0] * width / constants_1.layoutWidth;
        var h = p[1] * height / constants_1.layoutHeight;
        var x = p[2] * width / constants_1.layoutWidth;
        var y = p[3] * height / constants_1.layoutHeight;
        scaledPositions.push([w, h, x, y]);
    });
    return scaledPositions;
};
// returns [containerStyle, videoStyle, wrapperStyle]
var getStyles = function (numberOfStreams, selectedLayout, width, height) { return function (index, dominantTalker) {
    var base = {
        display: 'flex',
        position: 'absolute',
    };
    var availableHeight = height;
    var availableWidth = availableHeight * constants_1.aspectRatio_16to9;
    if (availableWidth > width) {
        availableWidth = width;
        availableHeight = width / constants_1.aspectRatio_16to9;
    }
    var layout = getLayout(numberOfStreams, selectedLayout, availableWidth, availableHeight);
    var xOffset = (width - availableWidth) / 2;
    var yOffset = (height - availableHeight) / 2;
    // define the video area
    var wrapperStyle = {
        height: availableHeight + "px",
        overflow: 'hidden',
        position: 'relative',
        left: xOffset + "px",
        top: yOffset + "px",
        width: availableWidth + "px"
    };
    if (index >= layout.length) {
        return [
            __assign({}, base),
            {},
            wrapperStyle
        ];
    }
    var highlighted = (selectedLayout === __1.constants.SFU_LAYOUT_GALLERY && numberOfStreams > 1 && dominantTalker);
    var margin = constants_1.borderWidth;
    var heightMargin = margin / constants_1.aspectRatio_16to9;
    if (highlighted) {
        var tileWidth = layout[index][0] * constants_1.highlightSizeIncrease;
        var tileWidthIncrease = tileWidth - layout[index][0];
        layout[index][0] = tileWidth;
        var tileHeight = layout[index][0] / constants_1.aspectRatio_16to9;
        var tileHeightIncrease = tileHeight - layout[index][1];
        layout[index][1] = tileHeight;
        if (layout[index][2] + layout[index][0] >= availableWidth) {
            layout[index][2] = Math.max(0, layout[index][2] - tileWidthIncrease);
        }
        else {
            layout[index][2] = Math.max(0, layout[index][2] - (tileWidthIncrease / 2));
        }
        if (layout[index][3] + layout[index][1] >= availableHeight) {
            layout[index][3] = Math.max(0, layout[index][3] - tileHeightIncrease);
        }
        else {
            layout[index][3] = Math.max(0, layout[index][3] - (tileHeightIncrease / 2));
        }
        margin = 0;
        heightMargin = 0;
    }
    var widthPx = (layout[index][0] - (2 * margin)) + "px";
    var heightPx = (layout[index][1] - (2 * heightMargin)) + "px";
    var leftPx = layout[index][2] + "px";
    var topPx = layout[index][3] + "px";
    var videoStyle = {
        height: '100%'
    };
    if (highlighted) {
        videoStyle['border'] = "solid 3px " + ux_assets_1.colors.stickynoteYellow;
        videoStyle['padding'] = '1px';
        videoStyle['backgroundColor'] = 'black';
        videoStyle['maxWidth'] = widthPx;
    }
    return [
        __assign(__assign({}, base), { height: heightPx, width: widthPx, left: leftPx, top: topPx, margin: heightMargin + "px " + margin + "px", zIndex: highlighted ? 10 : 0 }),
        videoStyle,
        wrapperStyle
    ];
}; };
exports.default = getStyles;
